<template>
  <div class="change-section fiat-section">

    <div class="amount-container">
      <v-select class="select"
                :clearable="false"
                :searchable="false"
               :options="currencyValues"
               placeholder="Country"
                :value="giveCurrency.code"
                @input="chooseCurrency($event)"
      />
      <input :value="giveAmount" @input="$emit('update:give-amount',  $event.target.value); changeTakeAmount($event.target.value);" type="text" class="input">
    </div>

<!--    {{ currencies }}-->

<!--    <div class="input-container">-->
<!--      <input type="number" :value="giveAmount"  @input="$emit('update:give-amount',  $event.target.value); changeTakeAmount($event.target.value);"/>-->
<!--      <div v-if="giveCurrency.title == 'Euro'" class="desc">EUR</div>-->
<!--      <div v-else-if="giveCurrency.title == 'US dollar'" class="desc">USD</div>-->
<!--      <div v-else class="desc">{{giveCurrency.title}}</div>-->
<!--    </div>-->
<!--    <div class="radio-buttons">-->
<!--      <div class="desc align-left">Choose a currency:</div>-->
<!--      <div class="list" v-if="currencies">-->
<!--        <div class="item" v-for="item in currencies" :key="item.title">-->
<!--          <label>-->
<!--            <input type="radio" :checked="giveCurrency.title === item.title" :value="item.title" @change="chooseCurrency(item)"/>-->
<!--            <div v-if="item.title == 'Euro'" class="desc">EUR</div>-->
<!--            <div v-else-if="item.title == 'US dollar'" class="desc">USD</div>-->
<!--            <div v-else class="desc">{{item.title}}</div>-->
<!--          </label>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div v-if="$parent.fiatToCrypto" class="radio-list payment-method-list">-->
<!--      <div class="desc align-left">Payment method:</div>-->
<!--      <div class="list">-->
<!--        <div class="item">-->
<!--          <label>-->
<!--            <input type="radio" v-model="paymentMethod" @change="$emit('update:payment-method', $event)" name="paymentMethod" value="card"/>-->
<!--            <div class="text">-->
<!--              <div class="desc">Visa/MasterCard</div>-->
<!--            </div>-->
<!--          </label>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: 'FiatSection',
  components: {
    vSelect
  },
  props: {
    giveCurrency : {
      type: Object
    },
    giveAmount: {
      type: Number
    },
    defaultTakeCurrency: {
      type: Function
    },
    currencies: {
      type: Object
    },
    paymentMethod: {
      type: String
    },
    changeTakeAmount: {
      type: Function
    },
    toggleFiatToCrypto: {
      type: Function
    }
  },
  data: function () {
    return {
      currenciesArr: [
        'EUR',
        'USD',
        'CAD'
      ]
    }
  },
  methods: {
    chooseCurrency(event) {
      console.log(event, 'fiat currency');
      this.$emit('update:give-currency', this.currencies[event]);
      this.defaultTakeCurrency();
    }
  },
  computed: {
    currencyValues() {
      return Object.entries(this.currencies).map(([currency,]) => {
        return currency;
      })
    }
  },
  mounted() {
  }
}
</script>
